export type EmpClientInfo = {
  channel: 'web' | 'tab' | 'mob' | 'app';
  os?: 'ios' | 'android' | null;
  version?: string;
};

export const EMP_CLIENT_INFO_COOKIE = 'EMP-CLIENT-INFO';

const VALID_CHANNELS: ReadonlyArray<EmpClientInfo['channel']> = ['web', 'tab', 'mob', 'app'];
const VALID_OS: ReadonlyArray<NonNullable<EmpClientInfo['os']>> = ['ios', 'android'];

const isValidChannel = (value: unknown): value is EmpClientInfo['channel'] =>
  typeof value === 'string' && (VALID_CHANNELS as readonly string[]).includes(value);

const isValidOs = (value: unknown): value is EmpClientInfo['os'] =>
  value === undefined ||
  value === null ||
  (typeof value === 'string' && (VALID_OS as readonly string[]).includes(value));

export const parseEmpClientInfo = (value: string | undefined): EmpClientInfo | null => {
  if (!value) return null;
  try {
    const decoded = JSON.parse(atob(value));
    if (
      typeof decoded === 'object' &&
      decoded !== null &&
      isValidChannel(decoded.channel) &&
      isValidOs(decoded.os)
    ) {
      return decoded as EmpClientInfo;
    }
    return null;
  } catch {
    return null;
  }
};

export const isAppChannel = (value: string | undefined): boolean =>
  parseEmpClientInfo(value)?.channel === 'app';
